<template>
  <div>
    <Head title="Productos" />
    <h1 class="mb-8 text-3xl font-bold">Productos</h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block text-gray-700">Familia:</label>
        <select v-model="form.family" class="form-select mt-1 w-full">
          <option :value="null" />
          <option v-for="family in families" :key="family.id" :value="family.id">{{ family.description }}</option>
        </select>
        <label class="block text-gray-700">Categoría:</label>
        <select v-model="form.category" class="form-select mt-1 w-full">
          <option :value="null" />
          <option v-for="category in categories" :key="category.id" :value="category.id">{{ category.description }}</option>
        </select>
      </search-filter>
      <Link class="btn-sky" href="/products/create">
        <span>Crear</span>
        <span class="hidden md:inline">&nbsp;Producto</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow">
      <div class="overflow-x-auto">
        <table class="w-full divide-y divide-gray-200">
          <thead>
            <tr class="text-left font-bold">
              <th scope="col" class="px-2 py-4">Imagen</th>
              <th scope="col" class="px-2 py-4">Código</th>
              <th scope="col" class="px-2 py-4">Descripción</th>
              <th scope="col" class="px-2 py-4">Precio <br /> (MXN)</th>
              <th scope="col" class="px-2 py-4">Familia</th>
              <th scope="col" class="px-2 py-4">Categoría</th>
              <th scope="col" class="px-2 py-4">U.M.</th>
              <th scope="col" class="px-2 py-4">Existencia</th>
              <th scope="col" class="px-2 py-4">Acciones</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-200">
            <tr v-for="product in products.data" :key="product.id" class="hover:bg-gray-50 ">
              <td class="px-4 py-4 text-center">
                <img 
                  v-if="product.imagen" class="w-5 h-5 rounded-full text-center"
                  :src="'/storage/' + product.imagen" 
                />
              </td>
              <td class="px-2 py-4">
                {{ product.codigo }}
              </td>
              <td class="px-2 py-4">
                <span class="text-sky-900 font-medium">
                  {{ product.descripcion }}
                </span>
              </td>
              <td class="px-2 py-4">
                <button 
                  class="text-blue-700 border border-blue-700 hover:bg-blue-700 hover:text-white focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2.5 text-center inline-flex items-center me-2"
                  type="button" 
                  @:click="showDialog(product.id)"
                >
                  $
                </button>
              </td>
              <td class="px-2 py-4">
                {{ getFamilyDescription(product.familia) }}
              </td>
              <td class="px-2 py-4">
                {{ getCategoryDescription(product.categoria) }}
              </td>
              <td class="px-2 py-4">
                {{ getUnitDescription(product.unidad_de_medida) }}
              </td>
              <td class="px-2 py-4 text-center">
                {{ product.existencias }}
              </td>
              <td class="px-2 py-4">
                <div class="flex items-center space-x-2">
                  <Link :href="`/products/${product.id}/edit`">
                    <button class="focus:outline-none text-white bg-green-500 hover:bg-green-800 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                        <path fill="currentColor" d="m18.988 2.012l3 3L19.701 7.3l-3-3zM8 16h3l7.287-7.287l-3-3L8 13z" />
                        <path fill="currentColor" d="M19 19H8.158c-.026 0-.053.01-.079.01c-.033 0-.066-.009-.1-.01H5V5h6.847l2-2H5c-1.103 0-2 .896-2 2v14c0 1.104.897 2 2 2h14a2 2 0 0 0 2-2v-8.668l-2 2z" />
                      </svg>                    
                    </button>              
                  </Link>
                  <button class="focus:outline-none text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5" @click="removeProduct(product.id)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                      <path fill="currentColor" d="M6 7H5v13a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7zm4 12H8v-9h2zm6 0h-2v-9h2zm.618-15L15 2H9L7.382 4H3v2h18V4z" />
                    </svg>                       
                  </button>
                </div>
              </td>
            </tr>
            <tr v-if="products.data.length === 0">
              <td class="px-6 py-4 text-center" colspan="9">No se encontraron productos.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination class="mt-6" :links="products.links" />
  </div>

  <div>    
    <DialogPrices v-if="showDialogInput" label="Nombre" :title="titleDialog" @close="closeDialog">      
      <ul class="space-y-2 text-left text-gray-500 dark:text-gray-400">
        <template v-for="(price, index) in pricesSelected" :key="price.id">               
          <li class="flex items-center space-x-3 rtl:space-x-reverse"> 
            <svg class="flex-shrink-0 w-3.5 h-3.5 text-green-500 dark:text-green-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 12">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5.917 5.724 10.5 15 1.5"/>
            </svg> 
            <span>Por caja: <span class="font-semibold text-gray-900">${{ price.price.toFixed(2) }}</span></span>
          </li>
          <li class="flex items-center space-x-3 rtl:space-x-reverse">
            <svg class="flex-shrink-0 w-3.5 h-3.5 text-green-500 dark:text-green-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 12">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5.917 5.724 10.5 15 1.5"/>
            </svg>
            <span>Por unidad: <span class="font-semibold text-gray-900">{{ price.unit_price.toFixed(2) }}</span></span>
          </li>
          <li class="flex items-center space-x-3 rtl:space-x-reverse">
            <svg class="flex-shrink-0 w-3.5 h-3.5 text-green-500 dark:text-green-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 12">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5.917 5.724 10.5 15 1.5"/>
            </svg>
            <span>Impuesto: <span class="font-semibold text-gray-900">{{ price.taxone }}</span></span>
          </li>
          <hr>  
        </template>
      </ul>
    </DialogPrices>
  </div>
</template>
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import Pagination from '@/Shared/Pagination'
import Icon from '@/Shared/Icon'
import DialogPrices from '@/Shared/Dialog'
import Swal from 'sweetalert2'
export default {
  components: {
    Head,
    Link,
    SearchFilter,
    Pagination,
    Icon,
    DialogPrices
  },
  layout: Layout,
  props: {
    filters: Object,
    products: Object,
    families: Object,
    categories: Object,
    productCategories: Array,
    productFamilies: Array,
    productUnits: Array,
    productTaxes: Array,
    price_types:Array
  },
  data() {
    return {
      showDialogInput: false, // Nuevo dato para controlar la visibilidad del diálogo
      pricesSelected:[],
      titleDialog:'',
      form: {
        search: this.filters.search,
        family: this.filters.family,
        category: this.filters.category,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/products', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    getTaxDescription(number) {
      const tax = this.productTaxes.find(cat => cat.id === number);
      return tax ? tax.descripcion : 'Impuesto no disponible';
    },
    getFamilyDescription(number) {
      const family = this.productFamilies.find(cat => cat.id === number);
      return family ? family.descripcion : 'Familia no disponible';
    },
    getCategoryDescription(number) {
      const category = this.productCategories.find(cat => cat.id === number);
      return category ? category.descripcion : 'Categoría no disponible';
    },
    getUnitDescription(number) {
      const unit = this.productUnits.find(cat => cat.id === number);
      return unit ? unit.codigo : 'Unidad de medida no disponible';
    },
    getNamePriceType(number) {
      const unit = this.price_types.find(cat => cat.id === number);
      let name_price_default = "Precio "+number
      return unit ? unit.name : name_price_default;
    },
    showDialog(id) {
      const product = this.products.data.find(product => product.id == id);
      this.titleDialog = product.descripcion
      this.pricesSelected = product.precios;
      this.showDialogInput = true // Mostrar el diálogo al hacer clic en el botón
    },
    closeDialog() {
      this.showDialogInput = false // Cerrar el diálogo cuando se emite el evento 'close'
    },
    removeProduct(idProduct){
      Swal.fire({
        title:'Remover producto',
        text:'¿Desea remover el producto?',
        icon:'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Remover',
      }).then((result)=>{
        if(result.isConfirmed){
          this.$inertia.put(`/products/${idProduct}/delete`)
        }
      });
    }
  },
}
</script>

<style>
.span-status {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  padding: 3px 5px;
  color: white;
  font-weight: bold;
  border-radius: 2px;
  border-radius: 9999px;
}

.status-enabled {
  background-color: #009933;
}

.status-disabled {
  background-color: #990000;
}
</style>